import { Assessment, RemediationQuestionAnswer } from './assessment.interface';
import { Domain } from './domain.interface';
import { Badge } from './users.interface';

export interface Questionnaire {
  id: number;
  title: string;
  description: string;
  version: string;
  slug: string;
  domains: Domain[];
  errors?: any;
  isPublished?: boolean;
  type?: string;
  versions?: Questionnaire[];
  bestPracticeGuidanceLink?: string;
  includeInReporting?: boolean;
}

export interface QuestionnaireResultArray {
  count: number;
  next: string;
  previous: string;
  results: Questionnaire[];
}

export enum ReportVersion {
  v5_1 = '5.1.0',
  v5_2 = '5.2.0',
  v5_3 = '5.3.0',
  v5_3_1 = '5.3.1',
}

export interface AssignedTpnAdminReviewer {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface RemediationValidationAdminRow {
  id: number;
  application: any | null;
  assessment: Assessment;
  assessmentSurvey: number;
  assessor: number;
  assignedAssessor: number;
  assignedTpnAdminReviewer: AssignedTpnAdminReviewer;
  badges: Badge[];
  baseline: number;
  bpSurvey: number;
  createdAt: string;
  data: any | null;
  isActive: boolean;
  latestControlsUpdatedAt: string;
  newAssessment: boolean;
  questionnaireVersion: string;
  questionsToValidateCount: number;
  remediationQuestionAnswers: RemediationQuestionAnswer[];
  reportIssueDate: string;
  serviceProvider: number;
  serviceProviderAdmin: string;
  serviceProviderName: string;
  site: number;
  siteOrAppName: string;
  status: string;
  subControlsRejectedCount: number;
  subControlsRemediationPlanWillRemediateLaterCount: number;
  subControlsToValidateCount: number;
  subControlsWithEvidenceCount: number;
  updatedAt: string;
  version: string | null;
  workflowType: string;
}